import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SpinnerIcon } from "@/lib/icons";

export function SaveAsTemplateSetDialog({
  open,
  onOpenChange,
  sourceName,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sourceName: string;
  onConfirm: (name: string, description: string | null) => Promise<void>;
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setName(`${sourceName} (kopio)`);
      setDescription("");
      setError(null);
    }
  }, [open, sourceName]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Tallenna nimellä</DialogTitle>
          <DialogDescription>
            Luo kopio tehtäväpohjasta. Kopiota voi muokata, kunnes se otetaan
            käyttöön hankkeessa.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="copy-name">Nimi</Label>
            <Input
              id="copy-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="copy-description">Kuvaus</Label>
            <Textarea
              id="copy-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Peruuta
          </Button>
          <Button
            disabled={!name.trim() || saving}
            onClick={async () => {
              setSaving(true);
              setError(null);
              try {
                await onConfirm(name.trim(), description.trim() || null);
                onOpenChange(false);
              } catch (e) {
                setError(
                  e instanceof Error ? e.message : "Kopiointi epäonnistui"
                );
              } finally {
                setSaving(false);
              }
            }}
          >
            {saving && <SpinnerIcon className="mr-2 h-4 w-4 animate-spin" />}
            Tallenna kopio
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
